import React, { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellIcon } from '../../../assets/svg/SVGComponents';
import {
  Container,
  NotificationList,
  NotificationSection,
  NotificationTime,
  Title,
} from './styles';
import { useAuth } from '../../../hooks/auth';
import { useNotification } from '../../../hooks/notifications';
import api, { setupNotificationInterceptor } from '../../../services/api';
import { formatRelativeDate } from '../../../utils/formatRelativeDate';
import {
  INotificationItem,
  defaultNotificationIcon,
  mapNotificationToItem,
} from '../../../utils/mapNotificationToItem';

// import { Container } from './styles';

const ProfileNotifications: React.FC = () => {
  const { user } = useAuth();
  const { notifications, addNotifications } = useNotification();
  const navigate = useNavigate();

  // Mesmo mapeamento do painel do header: ícone por type e deep link. Esta
  // página ignorava o type e mostrava o ícone de curtida em tudo.
  const notificationsItems = useMemo(
    (): INotificationItem[] => notifications.map(mapNotificationToItem),
    [notifications],
  );

  const handleNotificationClick = useCallback(
    (notification: INotificationItem) => {
      if (notification.link) {
        navigate(notification.link);
      }
    },
    [navigate],
  );

  useEffect(() => {
    setupNotificationInterceptor(addNotifications);
  }, [addNotifications]);

  useEffect(() => {
    if (user) {
      api.get(`/notifications`).then(response => {
        addNotifications(response.data.notifications);
      });
    }
  }, [user, addNotifications]);

  return (
    <Container className="notifications-area">
      <Title>
        <BellIcon
          width="1.7rem"
          stroke="#323232"
          strokeWidth={1.5}
          fill="none"
        />
        <h1>Notificações</h1>
      </Title>
      <NotificationSection>
        <NotificationList>
          {notificationsItems.map(notification => (
            <li key={notification.id}>
              <button
                type="button"
                onClick={() => handleNotificationClick(notification)}
              >
                <img
                  src={notification.icon_url || defaultNotificationIcon}
                  alt="icon-notification"
                />
                <div>
                  <p>
                    <b>{notification.title}</b> {notification.message}
                  </p>
                  <NotificationTime>
                    {formatRelativeDate(notification.created_at)}
                  </NotificationTime>
                </div>
              </button>
            </li>
          ))}
        </NotificationList>
      </NotificationSection>
    </Container>
  );
};

export default ProfileNotifications;
